var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4974_616)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1206 11.0017V14.8966H0.879883V10.7583",
    stroke: "currentColor",
    strokeWidth: 0.750192,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.27305 1.10303C9.27305 0.895867 9.10511 0.727931 8.89795 0.727931C8.69079 0.727931 8.52285 0.895867 8.52285 1.10303L9.27305 1.10303ZM8.63272 12.2996C8.7792 12.446 9.0167 12.446 9.16318 12.2996L11.5503 9.91246C11.6968 9.76597 11.6968 9.52848 11.5503 9.38199C11.4038 9.23551 11.1663 9.23551 11.0198 9.38199L8.89795 11.5039L6.77608 9.38199C6.6296 9.23551 6.3921 9.23551 6.24562 9.38199C6.09913 9.52847 6.09913 9.76597 6.24562 9.91246L8.63272 12.2996ZM8.52285 1.10303L8.52285 12.0343L9.27304 12.0343L9.27305 1.10303L8.52285 1.10303Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4974_616"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3b58bff51936a4a17f79a01249063a4b.svg";
export { ForwardRef as ReactComponent };